import React, { Component } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import { homeStoreSelectors } from "../../../home/store/store";

import { connect, Provider } from "react-redux";
import "./UserProfilePage.component.scss";
import { RouteComponentProps } from "react-router";
import { USER_ACTIONS } from "../UsersManagement/UserCreation/UserCreationPage.component";
import UserCreationPage from "../UsersManagement/UserCreation/UserCreationPage.component";
import { authStore } from "../../store/store";
import { HomeActionCreators } from "../../../home/actions/actionCreators";
import { ActionCreator } from "../../../../actions/actions";
import { User } from "../../reducers/users.reducer";
import PasswordInput from "../AuthPage/UtilFormInputs/PasswordInput/PasswordInput.component";
import ValidationPill from "../AuthPage/SignupCard/SignupForm/ValidationPill/ValidationPill.component";
import { validationPillStrings } from "../AuthPage/SignupCard/SignupForm/ValidationPill/ValidationPill.string";
import SubmitButton from "../AuthPage/UtilFormInputs/SubmitButton/SubmitButton.component";

export interface UserProfileProps extends RouteComponentProps {
    userInfo: User;
    getUserInfo: ActionCreator;
    editPassword: ActionCreator;
}

export interface UserProfileState {
    visible: boolean;
    drawer_values: {
        drawer_title: string;
        user_obj: User;
        form_button_name: string;
        user_action: string;
    };
}

const MIN_PASS_LENGTH = 8;
const LOWER_CASE_REGEX = /(?=.*[a-z])/;
const UPPER_CASE_REGEX = /(?=.*[A-Z])/;
const DIGIT_REGEX = /(?=.*\d)/;
const SYMBOL_REGEX = /[-!$#%^&*@()_+|~=`{}\[\]:";'<>?,.\/]/;

function equalTo(ref, msg) {
    return this.test({
        name: "equalTo",
        exclusive: false,
        message: msg || "${path} must be the same as ${reference}",
        params: {
            reference: ref.path
        },
        test: function (value) {
            return value === this.resolve(ref);
        }
    });
}

Yup.addMethod(Yup.string, "equalTo", equalTo);

const validationSchema = Yup.object().shape({
    password: Yup.string().required("Current Password is required"),
    new_password: Yup.string()
        .required("New Password is required")
        .matches(LOWER_CASE_REGEX, "Password must contain lower case character")
        .matches(UPPER_CASE_REGEX, "Password must contain upper case character")
        .matches(DIGIT_REGEX, "Password must contain digit")
        .matches(SYMBOL_REGEX, "Password must symbol (@$%*?&)")
        .min(MIN_PASS_LENGTH, `MIN_LENGTH{${MIN_PASS_LENGTH}}`),
    confirm_password: Yup.string()
        .required("Password confirmation is required")
        //@ts-ignore
        .equalTo(Yup.ref("new_password"))
});

class UserProfilePage extends Component<UserProfileProps, UserProfileState> {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            drawer_values: {
                drawer_title: "Edit Profile",
                user_obj: props.userInfo,
                form_button_name: "Update Settings",
                user_action: USER_ACTIONS.EDIT_PROFILE
            }
        };
        this.handleOnClickCancelButton = this.handleOnClickCancelButton.bind(
            this
        );
    }

    handleOnClickCancelButton() {
        this.setState({ visible: false });
        this.props.history.goBack();
    }

    componentDidMount(): void {
        this.props.getUserInfo();
    }

    componentDidUpdate(
        prevProps: Readonly<UserProfileProps>,
        prevState: Readonly<UserProfileState>,
        snapshot?: any
    ): void {
        if (prevProps.userInfo !== this.props.userInfo) {
            const drawer_values_copy = { ...this.state.drawer_values };
            drawer_values_copy["user_obj"] = this.props.userInfo;
            this.setState({ drawer_values: drawer_values_copy });
        }
    }

    onSubmitChange(values) {
        this.props.editPassword({
            user_id: this.props.userInfo.id,
            user_info: values
        });
    }

    render() {
        return (
            <Provider store={authStore}>
                <div
                    id="UserProfileBasicInfo"
                    className={
                        this.state.visible
                            ? "visible fade-enter-done"
                            : "fade-enter-done"
                    }
                >
                    <div className="sidebar-layout">
                        <div className="config-content">
                            <div className="container">
                                <div className="user-profile-area-header">
                                    <h1>My Profile Settings</h1>
                                    <button
                                        className="button_label_style"
                                        onClick={this.handleOnClickCancelButton}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                            <div className="container">
                                <UserCreationPage
                                    drawer_values={this.state.drawer_values}
                                />
                            </div>
                            <div className="container password-change">
                                <hr />
                                <div>
                                    <h2>Change Password</h2>
                                    <Formik
                                        initialValues={{
                                            password: "",
                                            new_password: "",
                                            confirm_password: ""
                                        }}
                                        onSubmit={values =>
                                            this.onSubmitChange(values)
                                        }
                                        validationSchema={validationSchema}
                                        render={props => {
                                            return (
                                                <Form>
                                                    <div className="input-group">
                                                        <label htmlFor="password">
                                                            Current Password
                                                        </label>
                                                        <Field
                                                            className="auth-form-input"
                                                            name="password"
                                                            placeholder="Current Password"
                                                            component={
                                                                PasswordInput
                                                            }
                                                        />
                                                    </div>
                                                    <div className="input-group"></div>
                                                    <div className="input-group">
                                                        <label htmlFor="new_password">
                                                            New Password
                                                        </label>

                                                        <Field
                                                            className="auth-form-input"
                                                            name="new_password"
                                                            placeholder="New Password"
                                                            component={
                                                                PasswordInput
                                                            }
                                                        />
                                                    </div>
                                                    <div className="input-group confirm">
                                                        <label htmlFor="confirm_password">
                                                            Confirm Password
                                                        </label>

                                                        <Field
                                                            className="auth-form-input"
                                                            name="confirm_password"
                                                            label="Confirm Password"
                                                            placeholder="Confirm Password"
                                                            component={
                                                                PasswordInput
                                                            }
                                                        />
                                                    </div>

                                                    <div id="password-validators-container">
                                                        <ValidationPill
                                                            pattern={
                                                                LOWER_CASE_REGEX
                                                            }
                                                            caption={
                                                                validationPillStrings.LOWER_CASE
                                                            }
                                                            currentPassword={
                                                                props.values
                                                                    .new_password
                                                            }
                                                        />
                                                        <ValidationPill
                                                            pattern={
                                                                UPPER_CASE_REGEX
                                                            }
                                                            caption={
                                                                validationPillStrings.UPPER_CASE
                                                            }
                                                            currentPassword={
                                                                props.values
                                                                    .new_password
                                                            }
                                                        />
                                                        <ValidationPill
                                                            pattern={
                                                                DIGIT_REGEX
                                                            }
                                                            caption={
                                                                validationPillStrings.DIGITS
                                                            }
                                                            currentPassword={
                                                                props.values
                                                                    .new_password
                                                            }
                                                        />
                                                        <ValidationPill
                                                            pattern={
                                                                SYMBOL_REGEX
                                                            }
                                                            caption={
                                                                validationPillStrings.SYMBOLS
                                                            }
                                                            currentPassword={
                                                                props.values
                                                                    .new_password
                                                            }
                                                        />
                                                    </div>
                                                    <div className="auth-form-btns">
                                                        <Field
                                                            component={
                                                                SubmitButton
                                                            }
                                                        />
                                                    </div>
                                                </Form>
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Provider>
        );
    }
}

const mapStateToProps = state => ({
    userInfo: homeStoreSelectors.userInfo(state)
});

const mapDispatchToProps = {
    getUserInfo: HomeActionCreators.getUserInfo,
    editPassword: HomeActionCreators.editPassword
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfilePage);
